import SuiTypography from "components/SuiTypography";
import SuiBox from "components/SuiBox";
import { globaleDateTimeFormatter } from "utils/helper";

const getReminderDateColor = (dateStr) => {
  if (!dateStr) return null;
  const d = new Date();
  const today = d.toISOString().split("T")[0];
  d.setDate(d.getDate() + 1);
  const tomorrow = d.toISOString().split("T")[0];
  d.setDate(d.getDate() + 1);
  const dayAfter = d.toISOString().split("T")[0];
  if (dateStr === today) return "#d32f2f";
  if (dateStr === tomorrow) return "#ed6c02";
  if (dateStr === dayAfter) return "#f9a825";
  return null;
};

export const DietChartRows = (charts, onClickHandler, navigate) => {
  const rows = charts.map((item) => {
    const dateColor = getReminderDateColor(item?.date);
    return {
      "Client Name": (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={{
            color: "#17C1E8",
            cursor: "pointer",
            paddingLeft: 14,
          }}
          onClick={() => {
            navigate(`/clients/${item.id}`);
          }}
        >
          {item?.name}
        </SuiTypography>
      ),
      "Dietitian Name": (
        <SuiTypography variant="button" fontWeight="medium">
          {item?.assignDietitian?.length > 0
            ? item?.assignDietitian?.map((dietitian, index) => (
                <span key={index}>{dietitian?.label}</span>
              ))
            : "N/A"}
        </SuiTypography>
      ),

      Date: (
        <SuiTypography
          variant="button"
          fontWeight="medium"
          style={dateColor ? { color: dateColor } : undefined}
        >
          {globaleDateTimeFormatter(item?.date, "date")}
        </SuiTypography>
      ),

      Action: (
        <SuiBox style={{ display: "flex" }}>
          <SuiTypography
            variant="button"
            fontWeight="medium"
            onClick={() => {
              navigate(`/dietchart?id=${item.id}`);
            }}
            style={{
              color: "#17C1E8",
              cursor: "pointer",
              paddingLeft: 16,
              textDecoration: "underline",
            }}
          >
            Create
          </SuiTypography>
        </SuiBox>
      ),
    };
  });

  return rows;
};
